import React from "react";
import { Box } from "@curves/ui-base";
import clsx from "clsx";

// 顯示所有量測資訊
const InBodyInterviewMeasureNormalBox = props => {
	const { formatCell, sourceData = [], itemKey, styles, className } = props;

	return (
		<React.Fragment>
			{sourceData.map((targetData, columnIndex) => {
				const { [itemKey]: cellVale } = targetData;
				return (
					<Box className={clsx("item", "text-center", className)} key={`${itemKey}_${columnIndex}`} style={{ width: "260px", ...styles }}>
						{formatCell ? formatCell(cellVale, targetData, { key: itemKey }) : cellVale}
					</Box>
				);
			})}
		</React.Fragment>
	);
};

export default InBodyInterviewMeasureNormalBox;
